<style lang="less" scoped>
    .btn-right-mes{
        margin-left:10px;
        line-height: 32px;
    }
    .withdrawal-mes{
        margin:0px 0px 16px 30px;
    }
    .red-tip{
        color: #F56C6C;
        font-size: 12px;
        margin-left:30px;
    }
</style>

<template>
    <div class="list-container">
        <div class="list-bread-crumb-div">
            <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
        </div>
        <div class="list-content-div">
            <div class="list-header-title-div">提现管理</div>
            <ZD-list-querys>
            </ZD-list-querys>
            <div class="page-action-btns flex">
                <button class="common-bg-button"  v-if="unCashOutFee == '0'"  @click="handleWithdrawal" disabled>提现申请</button>
                <button class="common-bg-button" v-else @click="handleWithdrawal">提现申请</button>
                <div class="btn-right-mes" v-if="unCashOutFee == '0'">当前无可提现金额</div>
                <div class="btn-right-mes" v-else>待提现金额：{{unCashOutFee}}元</div>
                <!-- <div class="flex-1"></div>
                <el-input size="small" style="width:320px;margin-right:10px;" class="list-serach-input" v-model="queryInfo.dealName" placeholder="请输入运营商名称" clearable></el-input>
                <button class="common-bg-button" @click="getListData(pagination,true)">搜索</button> -->
            </div>
            <!-- 表格 -->
            <div class="list-table">
                <ZD-table :tableColumns="pageConfig.listColumns" :operates="operates" :tableData="tableData" :tableConfig="pageConfig.tableConfig" :selections="selections" v-on:updateSelections="(sels)=>{selections=sels}"></ZD-table>
            </div>
            <!-- 分页 -->
            <div class="list-pagination">
                <ZD-pagination :pagination="pagination" v-on:pageUpdate="getListData"></ZD-pagination>
            </div>
            <el-dialog title="提现申请" :visible.sync="dialogFormVisible" width="30%" @close="handleDialogFormClose('form')">
                <div class="withdrawal-mes">申请人：{{userInfo.userName}}</div>
                <div class="withdrawal-mes">申请时间：{{applyDate}}</div>
                <div class="withdrawal-mes">可提现金额：{{unCashOutFee}}</div>
                <div class="flex" style="line-height:40px;">
                    <el-form :model="form" ref="form" :rules="pageConfig.formRules" label-width="100px">
                        <el-form-item label="提现金额" prop="applyMoney">
                            <el-input size="small" v-model="form.applyMoney"></el-input>
                        </el-form-item>
                    </el-form>
                    <div style="margin-left:20px;"><a @click="getCashOutFee">全部提现</a></div>
                </div>
                <div class="red-tip" v-if="tipFlag">提现金额不得超过可提现金额</div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="handleApply('form')" size="small">确 定</el-button>
                </div>
            </el-dialog>
            <el-dialog title="提现申请单" :visible.sync="dialogVisible" width="30%">
                <div class="withdrawal-mes">运营商：{{rowObj.dealerName}}</div>
                <div class="withdrawal-mes">提现订单编号：{{rowObj.cashOutNo}}</div>
                <div class="withdrawal-mes">提现申请人：{{rowObj.applyBy}}</div>
                <div class="withdrawal-mes">提现时间：{{rowObj.applyTime}}</div>
                <div class="withdrawal-mes">提现银行卡尾号：{{rowObj.applyBankCard}}</div>
                <div class="withdrawal-mes">提现金额：{{rowObj.applyMoney}}元</div>
                <div class="withdrawal-mes">提现状态：{{rowObj.chashOutStatusName}}</div>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false" size="small">关 闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import pageConfig from './page-config';
    import dateUtil from '../../../utils/dateUtils'
    export default {
        data() {
            return {
                pageConfig: pageConfig, // 页面配置
                tableData: [], // 表格数据
                selections: [], // 表格选项
                pagination: pageConfig.pagination,
                queryInfo: {},
                form:{},
                rowObj:{},
                operates: {
					width: 150,
					fixed: "right",
					list: [
						{
							id: "review",
                            label: "详情",
                            type:"primary",
							show: true,
							disabled: false,
							method: (index, row) => {
                                this.rowObj = row;
                                this.dialogVisible = true;
							}
						},
					]
                }, // 列操作按钮
                dialogFormVisible:false,
                dialogVisible:false,
                unCashOutFee:'0',
                userInfo:{},
                applyDate:'',
                tipFlag:false,
            }
        },
        methods: {
            init() {
                this.userInfo = this.$store.state.userInfo;
                this.getListData(this.pagination,true);
            },
            // 获取表格数据
            getListData(pagination, reload = false) {
                let _ = this;
                _.$U.showLoading(_);
                _.queryInfo.pageNum = pagination.current - 1;
                if (reload) {
                    this.pagination.current = 1;
                    _.queryInfo.pageNum = 0;
                }
                _.queryInfo.pageSize = pagination.pageSize;
                _.queryInfo.dealerNo = _.$store.state.userInfo.dealNo//_.userInfo.dealNo;
                _.$H.get(_, _.$A.finance.cashOut, _.queryInfo).then(res => {
                    _.tableData = res.data.data.cashOutEntityList.content || [];
                    _.pagination.total = res.data.data.cashOutEntityList.totalElements || 0;
                    _.unCashOutFee = res.data.data.unCashOutFee || 0;
                    _.$U.hideLoading(_);
                })
            },
            handleWithdrawal(){
                let _ = this;
                let date = new Date();
                _.applyDate = dateUtil.format(date);
                _.dialogFormVisible = true;
            },
            getCashOutFee(){
                let _ = this;
                let obj = {};
                obj.applyMoney = _.unCashOutFee;
                _.form = obj;
            },
            handleDialogFormClose(formName){
                this.form = {};
                this.dialogFormVisible = false;
                this.tipFlag = false;
                this.$refs[formName].resetFields();
            },
            handleApply(formName){
                let _ = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(_.form.applyMoney > _.unCashOutFee){
                            _.tipFlag = true;
                            return;
                        }
                        _.$U.showLoading(_);
                        _.form.applyBy = _.userInfo.userName;
                        _.form.createdByName = _.userInfo.createdByName;
                        _.form.dealerNo = _.$store.state.userInfo.dealNo//_.userInfo.dealNo;
                        _.form.applyByPhone = _.$store.state.userInfo.userPhone;
                        _.$H.post(_, _.$A.finance.addCashOut, _.form).then(res => {
                            _.$U.success("申请成功")
                            _.dialogFormVisible = false;
                            _.getListData(this.pagination);
                            _.$U.hideLoading(_);
                        })
                    }
                })
            }
        },
        mounted() {
            this.init();
        }
    }
</script>